import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const STORE_KEY = 'riot_clash2018'

let persistedStore = createPersistedState({
  key: STORE_KEY,
  storage: {
    getItem: key => Cookies.get(key),
    setItem: (key, value) => Cookies.set(key, value, { expires: 3, domain: '.leagueoflegends.com' }),
    removeItem: key => Cookies.remove(key)
  }
})

export default new Vuex.Store({
  state: {
    assemblePath: 'create',
    teamLogo: 'minion-bw',
    teamLogoImgPath: window.clash2018.versionedAssetPath + '/static/svg/minion-bw.svg',
    teamTag: '',
    teamName: '',
    teammatesChosen: 0,
    ticketChoice: 0,
    victoryPoints: 0,
    lootImg: 'orb-blue-small.png',
    tier: 4,
    isMobile: false,
    introAnimationPlayed: false,
    ticketRedemptionStatus: 0,
    timelineLinks: [
      {
        name: 'hero',
        unlocked: true,
        active: true,
        innerProgress: null,
        link: '/',
        translate: 46,
        index: 0
      },
      {
        name: 'assemble',
        unlocked: false,
        active: false,
        innerProgress: null,
        link: '/assemble',
        translate: 8,
        index: 1
      },
      {
        name: 'compete',
        unlocked: false,
        active: false,
        innerProgress: null,
        link: '/compete/scouting',
        translate: -29,
        index: 2
      },
      {
        name: 'champselect',
        unlocked: false,
        active: false,
        innerProgress: null,
        link: '/compete/champselect',
        translate: -67,
        index: 3
      },
      {
        name: 'bracket',
        unlocked: false,
        active: false,
        innerProgress: null,
        link: '/triumph/bracket',
        translate: -105,
        index: 4
      },
      {
        name: 'ticket',
        unlocked: false,
        active: false,
        innerProgress: null,
        link: '/ticket',
        translate: -142,
        index: 5
      }
    ]
  },
  mutations: {
    setAssemblePath (state, string) {
      state.assemblePath = string
    },
    setTeamTag (state, string) {
      state.teamTag = string
    },
    setTeamName (state, string) {
      state.teamName = string
    },
    setTeamLogo (state, string) {
      state.teamLogo = string
    },
    setTeamLogoImgPath (state, string) {
      state.teamLogoImgPath = window.clash2018.versionedAssetPath + '/static/svg/' + string + '.svg'
    },
    setTicketChoice (state, int) {
      state.ticketChoice = int
    },
    setVictoryPoints (state, number) {
      state.victoryPoints = number
    },
    setLootImg (state, string) {
      state.lootImg = string
    },
    setTier (state, number) {
      state.tier = number
    },
    setIsMobile (state, bool) {
      state.isMobile = bool
    },
    setIntroAnimationPlayed (state, bool) {
      state.introAnimationPlayed = bool
    },
    setTicketRedemptionStatus (state, number) {
      state.ticketRedemptionStatus = number
    },
    unlockTimelineLink (state, number) {
      state.timelineLinks[number].unlocked = true
    },
    activateTimelineLink (state, number) {
      state.timelineLinks[number].active = true
    },
    deactivateTimelineLink (state, number) {
      state.timelineLinks[number].active = false
    },
    setTimelineLinkInnerProgress (state, obj) {
      state.timelineLinks[obj.index].innerProgress = obj.innerProgress
    }
  },
  actions: {
    setAssemblePath ({commit}, string) {
      commit('setAssemblePath', string)
    },
    setTeamTag ({commit}, string) {
      commit('setTeamTag', string)
    },
    setTeamName ({commit}, string) {
      commit('setTeamName', string)
    },
    setTeamLogo ({commit}, string) {
      commit('setTeamLogo', string)
      commit('setTeamLogoImgPath', string)
    },
    setTicketChoice ({commit}, int) {
      commit('setTicketChoice', int)
    },
    setVictoryPoints ({commit, state}) {
      let victoryPoints = 600 + (400 - (state.tier * 100))
      commit('setVictoryPoints', victoryPoints)
    },
    setLootImg ({commit, state}, number) {
      let type = 'orb'
      if (state.ticketChoice === 1) {
        type = 'capsule'
      }
      let color = 'blue'
      if (number === 2) {
        color = 'purple'
      }
      commit('setLootImg', `${type}s/${type}-${color}-small.png`)
    },
    setTier ({commit}, number) {
      commit('setTier', number)
    },
    setIsMobile ({commit}, bool) {
      commit('setIsMobile', bool)
    },
    setIntroAnimationPlayed ({commit}, bool) {
      commit('setIntroAnimationPlayed', bool)
    },
    setTicketRedemptionStatus ({commit}, number) {
      commit('ticketRedemptionStatus', number)
    },
    unlockTimelineLink ({commit}, linkObj) {
      commit('unlockTimelineLink', linkObj.index)
      commit('activateTimelineLink', linkObj.index)
    },
    activateTimelineLink ({commit}, linkObj) {
      commit('activateTimelineLink', linkObj.index)
    },
    deactivateTimelineLink ({commit}, linkObj) {
      commit('deactivateTimelineLink', linkObj.index)
    },
    setTimelineLinkInnerProgress ({commit}, obj) {
      commit('setTimelineLinkInnerProgress', obj)
    }
  },
  plugins: [ persistedStore ],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js